import { Type } from "class-transformer";
import { EnaioDocument } from "src/modules/enaio/shared/EnaioDocument";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioDocumentResult {
    @Type(() => EnaioDocument)
    doc: EnaioDocument;
    token: string;
    seen = false;
    @Type(() => EnaioDocumentResult)
    remarkObjects: EnaioDocumentResult[];
    columns: OrdinaryObject;
}
